/**
 * Firebase environment loader.
 *
 * `FIREBASE_ENV` is injected at build time by Webpack (plugin) or Vite (web/admin).
 * Do not rely on runtime detection here — bundlers must set `process.env.FIREBASE_ENV`.
 *
 * Values:
 * - `development` — local dev; same Firebase project as staging (gantty-staging)
 * - `staging` — deployed staging
 * - `production` — deployed production (gantty-app)
 */

import stagingDefaults from './firebase.env.staging.js';
import productionDefaults from './firebase.env.production.js';

// Use `process.env.FIREBASE_ENV` without `?.` so Webpack DefinePlugin replaces it
// (optional chaining leaves runtime access, which is undefined in the browser → always fell back to development).
let env = process.env.FIREBASE_ENV || 'development';

/** @deprecated use FIREBASE_ENV=development */
if (env === 'localhost') {
  env = 'development';
}

const validEnvironments = ['development', 'staging', 'production'];
if (!validEnvironments.includes(env)) {
  throw new Error(
    `Invalid FIREBASE_ENV: "${env}". Must be one of: ${validEnvironments.join(', ')}.`
  );
}

let envConfig;
switch (env) {
  case 'development':
    envConfig = { ...stagingDefaults, environment: 'development' };
    break;
  case 'staging':
    envConfig = stagingDefaults;
    break;
  case 'production':
    envConfig = productionDefaults;
    break;
  default:
    throw new Error(`Unsupported environment: ${env}`);
}

const {
  environment,
  config,
  execSummaryFunctionUrl,
  changeSummaryFunctionUrl,
  exportUserDataFunctionUrl,
  deleteUserWithErasureReportFunctionUrl,
  chatbotFunctionUrl,
  holidaysFunctionUrl,
  datasetAccessRequestFunctionUrl,
} = envConfig;

export default {
  environment,
  config,
  execSummaryFunctionUrl,
  changeSummaryFunctionUrl,
  exportUserDataFunctionUrl,
  deleteUserWithErasureReportFunctionUrl,
  chatbotFunctionUrl,
  holidaysFunctionUrl,
  datasetAccessRequestFunctionUrl,
};

export {
  environment,
  config,
  execSummaryFunctionUrl,
  changeSummaryFunctionUrl,
  exportUserDataFunctionUrl,
  deleteUserWithErasureReportFunctionUrl,
  chatbotFunctionUrl,
  holidaysFunctionUrl,
  datasetAccessRequestFunctionUrl,
};
